.wrap {
  position: absolute;
  inset: 0;
  z-index: 9;
  display: grid;
  place-content: center;
  gap: 14px;
  background: rgba(5, 6, 7, 0.82);
  backdrop-filter: blur(8px);
  color: #fff;
  text-align: center;
  padding: 24px;
}

.wrap button {
  border: 0;
  background: linear-gradient(135deg, #e11d2e, #ff4d5a);
  color: #fff;
  padding: 11px 20px;
  border-radius: 999px;
  cursor: pointer;
  font-weight: 700;
  box-shadow: 0 8px 24px rgba(225, 29, 46, 0.35);
}
